import React, { useEffect, useState } from "react";
import styles from "./styles/ContentCalender.module.css";
import CalendarCard from "./SocialMediaCards";
import IdeaCanvasModal, { CanvasWrapper } from "./IdeaCanvasModal";
import IdeaCanvasBox from "./IdeaCanvasBox";
import log from "cslog";
import { useBotEndpoint } from "../_actions/bot";
import LoadingLottie from "../common/LoadingLottie";
import IdeaLoadingLottie from "../media/animations/idea_loading.json";

function CalendarCardsRenderer({
    items = [],
    me = {},
    isMobile = false,
    collapsible = true,
    className = "",
    rowStyle = false,
    compactStatus,
}) {
    const [open, setOpen] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);

    const mutationFestivalGen = useBotEndpoint(
        "/gen/generate_festival_data_new",
        () => {}
    );

    const handleClick = (item) => {
        setSelectedCard(item);
        setOpen(true);
    };

    if (selectedCard) {
        log.d(selectedCard, "selectedCard in CCR");
    }

    const getKey = (item, idx) =>
        item?.id ||
        item?.title ||
        `${item?.type || "item"}-${item?.date || item?.dt || idx}`;

    useEffect(() => {
        if (
            selectedCard?.type === "festival" &&
            !mutationFestivalGen.isSuccess &&
            !mutationFestivalGen.isLoading
        ) {
            log.p("Triggering festival gen in CCR");
            const payload = {
                primary_tag: selectedCard?.primary_tag?.name,
                event_id: selectedCard?.id,
                date: selectedCard?.date,
            };
            log.d(payload, "payload in CCR");
            mutationFestivalGen.mutate(payload, {
                onSuccess: (data) => {
                    log.d(data, "Result in CCR");
                    if (data?.success) {
                        setSelectedCard({
                            ...data?.data,
                            type: "entry",
                        });
                    }
                },
            });
        }
    }, [selectedCard, mutationFestivalGen]);

    return (
        <>
            <ul className={className}>
                {items.map((item, idx) => (
                    <CalendarCard
                        key={getKey(item, idx)}
                        item={item}
                        onClick={() => handleClick(item)}
                        collapsible={collapsible}
                        isMobile={isMobile}
                        compactStatus={compactStatus}
                    />
                ))}
            </ul>

            {selectedCard?.type === "festival_OLD" && (
                <IdeaCanvasBox
                    enable={open}
                    // data={{
                    //     stauts: "processed",
                    //     status: "processed",
                    //     data_type: "festival",
                    //     idea_processed: {
                    //         preset_id: selectedCard?.primary_tag?.id || "0e0c5b74-e8d5-4237-be1e-8e4ae3dded98",
                    //         block_id: "festival_message",
                    //         post_context: selectedCard?.name || "",
                    //         lang: null,
                    //         user_inputs: {},
                    //         extra: {},
                    //         template_id: "68a21db8-8149-4084-a55c-88fd25175fe3",
                    //         date: selectedCard?.date || selectedCard?.dt || new Date().toISOString(),
                    //         template_preview: selectedCard?.feature_image || ""
                    //     }
                    // }}
                    data={{
                        status: "generated",
                        generated_data: {
                            canvas: {
                                design: {
                                    preset_id:
                                        "0e0c5b74-e8d5-4237-be1e-8e4ae3dded98",
                                    primary_tag:
                                        selectedCard?.primary_tag?.name,
                                    prefill: {},
                                },
                            },
                        },
                    }}
                    onUpdate={(tdata) => {
                        log.d(tdata, "tdata in onUpdate");
                        const preset_inputs = Object.values(
                            tdata?.inputs?.frontSide
                        ).filter(
                            (val) => val?.block_type === "qureal_preset"
                        )?.[0];
                        const out = {
                            preset_id: preset_inputs?.data?.qureal_schema_id,
                            block_id: "festival_message",
                            post_context: preset_inputs?.data?.preset_context,
                            extra: preset_inputs?.data?.extra,
                            // user_prompt: "",
                            // user_inputs: {},
                            template_id: tdata?.id,
                            template_preview: tdata?.preview,
                        };
                        log.d(out, "out in onUpdate");

                        const payload = {
                            idea_processed: out,
                            status: "processed",
                        };
                    }}
                    loading={false}
                    open={open}
                    setOpen={setOpen}
                    me={me}
                />
            )}

            {selectedCard?.type === "entry" && (
                <IdeaCanvasModal
                    key={selectedCard?.id}
                    open={open}
                    setOpen={setOpen}
                    data={selectedCard}
                    me={me}
                />
            )}

            {selectedCard?.type === "festival" && (
                <CanvasWrapper open={open} setOpen={setOpen} title="Canvas">
                    <LoadingLottie
                        file={IdeaLoadingLottie}
                        style={{
                            width: 400,
                            height: 310,
                            marginTop: "-20px",
                        }}
                        wrapper_style={{
                            minHeight: "100vh",
                            width: "100%",
                        }}
                        text="Generating festival post..."
                        text_style={{
                            fontSize: "1.2em",
                            color: "var(--ant-color-text-tertiary)",
                        }}
                    />
                </CanvasWrapper>
            )}

            {selectedCard?.type === "external_post" && (
                <IdeaCanvasBox
                    enable={open}
                    data={{
                        status: "generated",
                        generated_data: {
                            canvas: {
                                external_post: selectedCard?.generated_data,
                            },
                        },
                    }}
                    entry_id={selectedCard?.id}
                    loading={false}
                    open={open}
                    setOpen={setOpen}
                    me={me}
                />
            )}
        </>
    );
}

export default CalendarCardsRenderer;
